export type ApplianceType =
    | 'commercial'
    | 'industrial'
    | 'comfort'
    | 'other'

export interface LeakRateInput {
    applianceType:ApplianceType;
    refrigerantAdded:number;
    fullSystemCharge:number;
    daysSinceLast:number;
}

export interface LeakRateResult {
    leakRatePercent:number;
    threshold:number|null;
    exceedsThreshold:boolean|null;
    repairWindowDays:number|null;
    industrialExtensionAvailable:boolean;
}

const THRESHOLDS:Record<ApplianceType, number|null> = {
    commercial: 20,
    industrial: 30,
    comfort: 10,
    other: null,
}

export function calcLeakRate (input:LeakRateInput):LeakRateResult {
    const {
        applianceType,
        refrigerantAdded,
        fullSystemCharge,
        daysSinceLast,
    } = input

    const leakRatePercent =
        (refrigerantAdded / fullSystemCharge) * (365 / daysSinceLast) * 100

    const threshold = THRESHOLDS[applianceType]
    const exceedsThreshold =
        threshold !== null ? leakRatePercent > threshold : null
    const repairWindowDays = exceedsThreshold ? 30 : null
    const industrialExtensionAvailable =
        applianceType === 'industrial' && exceedsThreshold === true

    return {
        leakRatePercent,
        threshold,
        exceedsThreshold,
        repairWindowDays,
        industrialExtensionAvailable,
    }
}
